

























import Vue from 'vue';

export default Vue.extend({
  name: 'Modal',
  props: {
    shownHeader: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '420px',
    },
  },
  data() {
    return {
      modelVisible: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.modelVisible = newVal;
    },
    modelVisible(newVal) {
      this.$emit('input', newVal);
    },
  },
});
